<template>
  <v-form ref="formRef" v-model="isValid">
    <!-- عنوان فروشگاه -->
    <v-text-field 
      v-model="form.title" 
      label="عنوان فروشگاه" 
      outlined 
      dense 
      :rules="[v => !!v || 'وارد کردن عنوان الزامی است', v => (v && v.length >= 3) || 'عنوان باید حداقل ۳ کاراکتر باشد']"
    />

    <!-- Base URL -->
    <v-text-field 
      v-model="form.base_url" 
      label="Base URL" 
      placeholder="https://example.com" 
      outlined 
      dense 
      dir="ltr" 
      :rules="urlRules"
    />

    <!-- Token -->
    <v-text-field 
      v-model="form.token" 
      label="Token" 
      outlined 
      dense 
      dir="ltr" 
      :rules="[v => !!v || 'وارد کردن توکن الزامی است', v => (v && v.length > 5) || 'توکن باید حداقل ۶ کاراکتر باشد']"
    />
    
    <!-- وضعیت فعال بودن -->
    <v-switch 
      v-model="form.active" 
      label="فعال بودن فروشگاه" 
      color="primary" 
      inset 
      dense 
      class="mt-0" 
    />

    <!-- عملیات‌های همگام‌سازی -->
    <div class="mt-2">
      <label class="text-caption grey--text">عملیات‌های فعال:</label>
      <v-chip-group 
        v-model="form.operations" 
        multiple 
        column 
        active-class="primary--text text--accent-4"
      >
        <v-chip filter value="sync_price">همگام‌سازی قیمت</v-chip>
        <v-chip filter value="sync_stock">همگام‌سازی موجودی</v-chip>
      </v-chip-group>
    </div>
  </v-form>
</template>

<script>
export default {
  name: "WooForm",
  data: () => ({
    isValid: false,
    form: {
      title: "",
      base_url: "",
      token: "",
      operations: [],
      active: true
    },
        urlRules: [
        v => !!v || "وارد کردن آدرس فروشگاه الزامی است",
        v => /^(https?:\/\/)/.test(v ? v.toLowerCase() : "") || "آدرس باید با http:// یا https:// شروع شود"
        ]
  }),
  watch: {
    isValid(val) {
      this.$emit("valid", val);
    }
  },
  methods: {
    setData(data) {
      if (!data) return;
      this.form.title = data.title || "";
      this.form.active = typeof data.active === "boolean" ? data.active : Boolean(data.active);
      this.form.operations = Array.isArray(data.operations) ? [...data.operations] : [];

      // استخراج connection (پوشش هم آبجکت و هم استرینگ احتمالی)
      const conn = typeof data.connection === "string" ? JSON.parse(data.connection || "{}") : (data.connection || {});
      this.form.base_url = conn.base_url || data.base_url || "";
      this.form.token = conn.token || data.token || "";

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.validate();
        }
      });
    },
    getData() {
      return {
        title: this.form.title ? this.form.title.trim() : "",
        type: "woocommerce",
        active: this.form.active,
        operations: this.form.operations || [],
        connection: {
          base_url: this.form.base_url ? this.form.base_url.trim() : "",
          token: this.form.token ? this.form.token.trim() : ""
        }
      };
    }
  }
};
</script>
